import { render, staticRenderFns } from "./DeliveryAddressWayBill.vue?vue&type=template&id=6b8fc91e&"
import script from "./DeliveryAddressWayBill.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressWayBill.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressWayBill.vue?vue&type=style&index=0&id=6b8fc91e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports